/* eslint-disable no-console, no-alert*/
/**
 * * Class CookiePopup that handles base functionality for hide show cookie-popup.
 * @class
 */
class Aedirectpopup {

	/**
	* Make a new CookiePopup.
	* @constructs
	* @param {HTMLElement} element - The HTMLElement this module is constructed upon
	*/
    constructor() {
        this.hcp = this.getCookie('hcplog');
        this.bindEvents();
        this.load();
    }

	/**
	* @param {HTMLElement} cname - The HTMLElement this module is constructed upon
	* @param {HTMLElement} cvalue - The HTMLElement this module is constructed upon
	* @param {HTMLElement} exdays - The HTMLElement this module is constructed upon
	*/
    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        const qw = d.getTime();
        const qe = exdays * 24 * 60 * 60 * 1000;
        d.setTime(qw + qe);
        const expires = `expires=${d.toUTCString()}`;
        document.cookie = `${cname}=${cvalue}; ${expires}`;
    }

	/**
	* @returns {string} - string
	* @param {HTMLElement} cname - The HTMLElement this module is constructed upon
	* @private
	*/
    getCookie(cname) {
        const name = `${cname}=`;
        const ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(name) === 0) { return c.substring(name.length, c.length); }
        }

        return '';
    }

	/**
	*/
    load() {
        if (this.hcp === 'hcp') {
		// Check cookie: if exists and hcp passes, allow user into site
            this.setCookie('hcplog', 'hcp', 1);
        } else {
		// If cookie does not exist, create modal window and ask user to respond
            document.getElementById('countrycheck').style.display = 'block';
        }
    }
	
	/**
	*/
    bindEvents() {
        document.getElementById('confirm').addEventListener('click', this.confirmPopup.bind(this));
    }

	/**
	* @param {HTMLElement} e - The HTMLElement this module is constructed upon
	*/
    confirmPopup(e) {
        e.preventDefault();
        this.hcp = 'hcp';
        this.setCookie('hcplog', 'hcp', 1);
        document.getElementById('countrycheck').style.display = 'none';
    }
}

export default Aedirectpopup;
